module.exports = __webpack_public_path__ + "static/media/equivalence-work.128ce035.svg";